"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    API_BASE_URL: 'https://radr-backend-dusky.vercel.app',
    API_ENDPOINTS: {
        VARIANTS: '/api/variants',
        VARIANT: '/api/variant',
    }
};
